import { render } from "./RmainingDetail.vue?vue&type=template&id=3645ee7c&scoped=true"
import script from "./RmainingDetail.vue?vue&type=script&lang=js"
export * from "./RmainingDetail.vue?vue&type=script&lang=js"

import "./RmainingDetail.vue?vue&type=style&index=0&id=3645ee7c&lang=scss&scoped=true"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3645ee7c"]])

export default __exports__